import Repo from './Repo.js'

export default class ElectricityBillRepository extends Repo {
  constructor () {
    super('electricity-bills')
  }

  all (q) {
      return super.all(q)
  }

  store (data) {
      return super.store(data)
  }

  update (id, data) {
      return super.update(id, data)
  }

  get (id) {
      return super.get(id)
  }

  delete (id) {
      return super.delete(id)
  }

  paginate (q) {
      return super.paginate(q)
  }

  search (data) {
      return this.http.get(this.resource + '/search', data).then((response) => {
          return Promise.resolve(response)
      }).catch((response) => {
          return Promise.reject(response)
      })
  }

  pdf (id, name = "Bill") {
      return this.http.download(this.resource + "/" + id + "/pdf", {}).then((response) => {
          let blob = new Blob([response.data], { type:   'application/pdf' } );
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = name+'.pdf';
          link.click();
          return Promise.resolve(response);
      }).catch((response) =>{
          return Promise.reject(response);
      });
   }
}
